import { useEffect, useRef } from 'react';

const plans = [
  { name: 'ミニマムプラン(12枚×2回)', price: '33万円', highlight: false },
  { name: 'ライトプラン(22枚×3回)', price: '44万円', highlight: false },
  { name: 'モデレートプラン(40枚×3回)', price: '66万円', highlight: false },
  { name: 'コンプリヘンシブ(無制限)プラン', price: '99万円', highlight: true },
];

export default function PhilosophyChapter05() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-up-item').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="chapter6" className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 fade-up">
          <p className="text-lg font-bold mb-4" style={{ color: '#3E5F8F' }}>05</p>
          <h2 className="text-3xl md:text-4xl font-normal text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            「先に申し込み」ではなく、<br />「先に診断」が医療の本来の姿です。
          </h2>
          <p className="text-base text-gray-700 leading-relaxed">
            多くの歯科医院では、<br />
            診断前に「一律の無制限プラン」が提示されます。<br />
            しかし、私たちはその方法を取りません。<br />
            理由は明確です。<br />
            「診断を行わなければ、必要な治療は誰にも分からないから」です。
          </p>
        </div>

        <div className="mb-12 bg-gray-50 rounded-lg p-8 fade-up">
          <h3 className="text-xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>あなたに「過不足のない」プランを。</h3>
          <p className="text-base text-gray-700 leading-relaxed mb-8">
            私たちはまず最初に診査・診断を行い、<br />
            歯を動かす量や期間を正確に特定します。<br />
            その結果、必要な分だけを費用に反映できるように、<br />
            複数の選択肢を用意しています。
          </p>
          <h4 className="text-lg font-bold text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>当院のマウスピース矯正プラン</h4>
          <div className="grid md:grid-cols-2 gap-6">
            {plans.map((plan, i) => (
              <div
                key={i}
                className={`rounded-lg p-6 border-2 transition-all duration-500 hover:-translate-y-1 fade-up-item ${plan.highlight ? 'bg-white' : 'bg-white'}`}
                style={{ borderColor: plan.highlight ? '#3E5F8F' : '#e5e7eb' }}
              >
                <p className="text-base font-bold text-gray-900 mb-2">{plan.name}</p>
                <p className="text-2xl font-bold" style={{ color: '#3E5F8F' }}>
                  {plan.price}<span className="text-sm text-gray-600">(税込)</span>
                </p>
              </div>
            ))}
          </div>
          <div className="mt-8 rounded-lg p-6 fade-up" style={{ backgroundColor: '#EEF3F9' }}>
            <p className="text-sm text-gray-700">
              顎の位置から根本的に整える特別な治療(スマーティGS)は、<br />
              180万円(税別)となります。
            </p>
          </div>
        </div>

        <div className="mb-12 bg-gray-50 rounded-lg p-8 fade-up">
          <h3 className="text-xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>なぜ診査・診断が「無料」なのか。</h3>
          <p className="text-base text-gray-700 leading-relaxed mb-8">
            「最初に診査診断を行い、治療法を提示する」。<br />
            この当たり前の順序を守ることが、医療機関としての誠実さだと私たちは考えています。
          </p>
          <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 fade-up-item">
              <p className="text-base font-bold text-gray-900 mb-2">本来の医療の流れを追求:</p>
              <p className="text-sm text-gray-700">診断を無料で行うことで、現状を正しく理解したうえで、納得して選べる環境を整えています。</p>
            </div>
            <div className="bg-white rounded-lg p-6 fade-up-item">
              <p className="text-base font-bold text-gray-900 mb-2">責任ある継続管理:</p>
              <p className="text-sm text-gray-700">治療開始後は、3か月に1回程度の頻度で、責任を持って経過を管理します(管理料:5,500円/回)。</p>
            </div>
          </div>
        </div>

        <div className="rounded-lg p-8 fade-up" style={{ backgroundColor: '#EEF3F9' }}>
          <h4 className="text-lg font-bold text-gray-900 mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>まとめ</h4>
          <p className="text-sm text-gray-700 leading-relaxed">
            費用は「装置の種類」で決まるのではなく、「あなたに必要な治療量」で決まります。<br /><br />
            診断前に費用は一切発生しません。<br />
            無料であなたの現状を調べ、過不足のないプランを一緒に確認しましょう。
          </p>
        </div>
      </div>
    </section>
  );
}